import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ENDPOINTS from '../../utils/api';

// Order Billing API (POST request)
export const fetchOrderBilling = createAsyncThunk(
  'billing/fetchOrderBilling',
  async ({ slug, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.ORDER_BILLING(slug),
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch order billing'
      );
    }
  }
);

const billingSlice = createSlice({
  name: 'billing',
  initialState: {
    billingData: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderBilling.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.billingData = action.payload;
      })
      .addCase(fetchOrderBilling.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch order billing';
      });
  },
});

export default billingSlice.reducer;
